'use strict';

var jquery = require('jquery');
global.jQuery = jquery;
global.$ = jquery;

var moment = require("moment");
global.moment = moment;

// Locale for momentJs
var htmlLang = $('html').attr('lang');
var momentJsLocale = $('html').data('frontendDateLocale');
var defaultLang = $('html').data('defaultLang');
var localeIsPending = true

if (momentJsLocale) {
	try {
		require('moment/locale/' + momentJsLocale);
		moment.locale(momentJsLocale);
		localeIsPending = false;
	} catch (error) {
		localeIsPending = true;
	}
}
if (htmlLang && localeIsPending) {
	try {
		require('moment/locale/' + htmlLang);
		moment.locale(htmlLang);
		localeIsPending = false;
	} catch (error) {
		localeIsPending = true;
	}
}
if (localeIsPending) {
	try {
		require('moment/locale/' + defaultLang);
		moment.locale(defaultLang);
	} catch (error) { /* do nothing */ }
}
window.moment = moment;


var jqueryMouseWheel = require('jquery-mousewheel');
var bootstrap_sass = require('bootstrap-sass');
var bootstrap_validator = require('bootstrap-validator');
var owl_carousel = require('owl.carousel');
var jqueryMatchHeight = require("jquery-match-height");
var select2 = require("select2");
var daterangepicker = require("daterangepicker");
var blazyRq = require("blazy");
var i18nLib = require("./i18n");

global.bLazy = new blazyRq();

global.$.validator = bootstrap_validator;
global.$.daterangepicker = daterangepicker;
global.$.jqueryMatchHeight = jqueryMatchHeight;



require('./authentic');
require('./bootstrap-spinner.min');

var isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;
if (isMobile) {
	$.fn.select2.defaults.set("minimumResultsForSearch", -1);
}

$('.menu-button-toggle').click(function () {
	$('.as-nav').toggleClass('mega-menu');
});

function phoneClickHandler () {
	var phoneNumber = $(this).data('phoneNumber');
	if (phoneNumber && String(phoneNumber).trim().length > 0) {
		window.open('tel:' + phoneNumber, '_self');
	}
}
$('.menu-button-group .button-phone-mobile[data-phone-number]').click(phoneClickHandler);
$('.modal').on('click', '.modal-get-in-touch__buttons a[data-phone-number]', phoneClickHandler);

$('.menu-button-group .button-search-mobile, #openSearchMobile').click(function () {
	$('.as-nav').toggleClass('mega-menu');
	$('section.search-content').addClass('searchOpen');
	$('.search-content-mobile #searchTerm').val('').trigger('focus');
});

$("body").on("click", ".button-to-top", function () {
	$('html,body').animate({
		scrollTop: 0
	}, 500);
});

$("body").on("click", ".remember-link", function () {
	$(".remember__form").toggle();
});

$("body").on("click", ".mask-toggle", function () {
	$(this).parent().prevUntil("h4", "section[class^=experiences-list]").each(function () {
		$(this).find(".section-mask, .mask > a:nth-child(1n+5)").toggle(600);
	});

	if ($(this).text() == i18nLib.localize("Show more"))
		$(this).text(i18nLib.localize("Show less"));
	else if ($(this).text() == i18nLib.localize("Show less"))
		$(this).text(i18nLib.localize("Show more"));

	$(this).toggleClass("hiding");
});

window.addEventListener('scroll', function (event) {
	//console.log(this.window.pageYOffset);
	if (this.window.pageYOffset > 300) {
		$(".button-to-top").css('display', 'flex');
		//console.log('block');
	} else {
		$(".button-to-top").hide();
		//console.log('hide');
	}
});

$(".travel-nav-tabs a").click(function () {
	$(".travel-nav-tabs a").removeClass("active");
	if ($(this).attr("data-tab") === "travel-info") {
		$("#tour-question").hide();
		$(".travel-info--wrap").show();
		$(this).addClass('active');
	} else {
		$("#tour-question").show();
		$(".travel-info--wrap").hide();
		$(this).addClass("active");
	}
});

if ($(".booking--details--form").length === 0) {
	$(".travel-nav-tabs").hide();
}


$('[data-network="email"]')
	.data('title', document.title).attr('data-title', document.title)
	.data('email-subject', document.title).attr('data-email-subject', document.title)



// WEBPACK FOOTER //
// ./src/main/resources/assets/js/main.js